/*-- import aliases -----------
'!/...' -> project root
'~/...' -> js folder root
-----------------------------*/
import { setup } from '~/core';
setup();

import '~/global/_body';
import '~/global/_alert';
import '~/global/_header';
import '~/global/_footer';
import '~/global/_siteModals';

import '~/components/_accordion';
import '~/components/_documentDownload';
import '~/components/_navSecondary';
import '~/components/_eventLists';
import '~/components/_carousel';
import '~/components/_nav';
import '~/components/_forms';
import '~/components/_rail-retach';
import '~/components/_video';
